<div >{{currentValue}}</div>